var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00006 16.2003L5.50006 12.7003C5.40853 12.6076 5.29953 12.5341 5.17937 12.4839C5.05921 12.4337 4.93028 12.4078 4.80006 12.4078C4.66983 12.4078 4.5409 12.4337 4.42074 12.4839C4.30058 12.5341 4.19158 12.6076 4.10006 12.7003C4.00742 12.7918 3.93387 12.9008 3.88367 13.0209C3.83347 13.1411 3.80762 13.27 3.80762 13.4003C3.80762 13.5305 3.83347 13.6594 3.88367 13.7796C3.93387 13.8997 4.00742 14.0087 4.10006 14.1003L8.29006 18.2903C8.68006 18.6803 9.31006 18.6803 9.70006 18.2903L20.3001 7.70025C20.3927 7.60873 20.4662 7.49973 20.5164 7.37957C20.5666 7.25941 20.5925 7.13048 20.5925 7.00025C20.5925 6.87003 20.5666 6.7411 20.5164 6.62094C20.4662 6.50078 20.3927 6.39177 20.3001 6.30025C20.2085 6.20761 20.0995 6.13406 19.9794 6.08386C19.8592 6.03366 19.7303 6.00781 19.6001 6.00781C19.4698 6.00781 19.3409 6.03366 19.2207 6.08386C19.1006 6.13406 18.9916 6.20761 18.9001 6.30025L9.00006 16.2003Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7f0d497d127442ce756608f1731372cb.svg";
export { ForwardRef as ReactComponent };